import { Col, ColProps } from 'antd'

export interface KBColProps extends ColProps {}

export function KBCol(props: KBColProps) {
  return <Col {...props}></Col>
}
